import CustomerHeader from "./components/CustomerHeader";
import ActiveSubscription from "./components/ActiveSubscription";
import NoSubscription from "./components/NoSubscription";
import { AssignedEmployee } from "./components/AssignedEmployee";
import { ThreeDots } from "react-loader-spinner";
import ActionButtons from "./components/ActionButtons";
import PlanMembers from "./components/PlanMembers";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetchMembers } from "./hooks/useFetchMembers";
import { ArrowLeft } from "lucide-react";

const Loading = () => {
  return (
    <div className="w-full flex items-center justify-center p-8">
      <ThreeDots
        visible={true}
        height="50"
        width="50"
        color="#2c5689"
        radius="9"
        ariaLabel="three-dots-loading"
      />
    </div>
  );
};

const CustomerDetails = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { customer } = location.state;

  const { data: members, isPending } = useFetchMembers(
    customer?.subscription?.id,
  );

  const name = customer
    ? [customer?.first_name, customer?.middle_name, customer?.last_name]
        .filter(Boolean)
        .join(" ")
        .trim()
    : "--";

  return (
    <div className="px-4 relative">
      <header className="py-3 pl-4 pr-8 w-full rounded-lg h-14 bg-white/30 backdrop-blur-sm shadow-md sticky top-0 z-50 flex items-center">
        <button
          className="p-2 rounded-full text-sm  hover:bg-gray-200 border flex items-center justify-center duration-300 ease-in-out transition-all"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="size-4" />
        </button>
        <h1 className="text-center text-lg font-semibold capitalize w-full">
          Customer Detials of {name}
        </h1>
      </header>

      <div className="relative max-w-6xl mx-auto my-8">
        <div className="sticky top-0">
          <CustomerHeader customer={customer} />
        </div>
        <div className="grid grid-cols-2 gap-4">
          {customer.subscription ? (
            <ActiveSubscription plan={customer.subscription} />
          ) : (
            <NoSubscription />
          )}
          <div className="flex flex-col gap-3">
            <div className="p-3 rounded-xl border">
              <h1 className="text-md font-medium mb-3">Assigned Employee</h1>
              <AssignedEmployee customerId={customer?.id} />
            </div>

            <ActionButtons customer={customer} members={members} />
          </div>
        </div>

        {customer.subscription && (
          <div className="p-3 border rounded-xl mt-4">
            <h1 className="text-md font-medium mb-3">Plan Members</h1>
            {isPending ? (
              <Loading />
            ) : (
              <div className="grid grid-cols-2 gap-x-3 gap-y-3">
                {Array.isArray(members) &&
                  members.map((member, index) => (
                    <PlanMembers member={member} index={index} />
                  ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerDetails;
